module.exports = __webpack_public_path__ + "static/img/10.01c8747.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/zh/10.png
// module id = YUZu
// module chunks = 0